let navItemShape = document.querySelector("#sorting-shape");
let navItemMetal = document.querySelector("#sorting-metal");
let navItemPrice = document.querySelector("#sorting-price");
let navItemStone = document.querySelector("#sorting-stone");
let navItemCarat = document.querySelector("#sorting-carat");

let contentShape = document.querySelector(
  ".navigation-tab__navigation-content_shape"
);
let contentMetal = document.querySelector(
  ".navigation-tab__navigation-content_metal"
);
let contentPrice = document.querySelector(
  ".navigation-tab__navigation-content_price"
);
let contentStone = document.querySelector(
  ".navigation-tab__navigation-content_stone"
);
let contentCarat = document.querySelector(
  ".navigation-tab__navigation-content_carat"
);

function hideAllContent() {
  if (contentShape) {
  contentShape.classList.add("content-shape-hide");    
  }
  if (contentMetal) {
    contentMetal.style.display = "none";
  }
  if (contentPrice) {
    contentPrice.style.display = "none";
  }
  if (contentStone) {
    contentStone.style.display = "none";
  }
  if (contentCarat) {
    contentCarat.style.display = "none";
  }
}

function changeAllColor() {
  if (navItemShape) {
  navItemShape.style.color = "#DFDDDC";    
  }


  if (navItemMetal) {
    navItemMetal.style.color = "#DFDDDC";
  }
 
  if (navItemPrice) {
    navItemPrice.style.color = "#DFDDDC";
  }
  
  if (navItemStone) {
  navItemStone.style.color = "#DFDDDC";  
  }
  
  if (navItemCarat) {
    navItemCarat.style.color = "#DFDDDC";
  }
}

if (navItemShape) {
navItemShape.addEventListener("click", function () {
  hideAllContent();
  changeAllColor()
  contentShape.classList.remove("content-shape-hide");
  contentShape.style.display = "flex";
  navItemShape.style.color = "black";
});  
}


if (navItemMetal) {
  navItemMetal.addEventListener("click", function () {
  hideAllContent();
  changeAllColor()
  contentMetal.style.display = "flex";
  navItemMetal.style.color = "black";
});
}


if (navItemPrice) {
  navItemPrice.addEventListener("click", function () {
  hideAllContent();
  changeAllColor()
  contentPrice.style.display = "flex";
  navItemPrice.style.color = "black";
});
}


if (navItemStone) {
  navItemStone.addEventListener("click", function () {
  hideAllContent();
  changeAllColor()
  contentStone.style.display = "flex";
  navItemStone.style.color = "black";
});
}



if (navItemCarat) {
  navItemCarat.addEventListener("click", function () {
  hideAllContent();
  changeAllColor()
  contentCarat.style.display = "flex";
  navItemCarat.style.color = "black";
});

}

